import { filterCoworkReportTemplates } from "./report-templates"

export const coworkReportCategories = {
  accounting: "cowork.enterprise.reportTemplates.accounting",
  financial: "cowork.enterprise.reportTemplates.financial",
  management: "cowork.enterprise.reportTemplates.management",
  riskCompliance: "cowork.enterprise.reportTemplates.riskCompliance",
  operations: "cowork.enterprise.reportTemplates.operations",
} as const

export type CoworkReportCategory = keyof typeof coworkReportCategories

const previewReports = [
  ["cash-flow", "financial"],
  ["budget-actual", "financial"],
  ["period-comparison", "financial"],
  ["financial-ratios", "financial"],
  ["revenue-analysis", "financial"],
  ["cost-analysis", "financial"],
  ["working-capital", "financial"],
  ["management-report", "management"],
  ["ceo-report", "management"],
  ["board-report", "management"],
  ["company-performance", "management"],
  ["group-performance", "management"],
  ["kpi-reporting", "management"],
  ["exception-report", "riskCompliance"],
  ["data-quality", "riskCompliance"],
  ["audit-readiness", "riskCompliance"],
  ["control-reconciliation", "riskCompliance"],
  ["procurement", "operations"],
  ["project-performance", "operations"],
  ["customer-analysis", "operations"],
] as const

export const coworkPreviewReportTemplates = previewReports.map(([id, category]) => ({
  id,
  category,
  kind: "preview" as const,
  country: null,
  titleKey: `cowork.enterprise.reportTemplates.preview.${id}.title` as const,
  descriptionKey: `cowork.enterprise.reportTemplates.preview.${id}.description` as const,
  sourcesKey: `cowork.enterprise.reportTemplates.preview.${id}.sources` as const,
  outputsKey: `cowork.enterprise.reportTemplates.preview.${id}.outputs` as const,
}))

const previewIDs = new Set<string>(coworkPreviewReportTemplates.map((template) => template.id))

export const coworkReportCatalog = [
  ...filterCoworkReportTemplates({})
    .filter((template) => !previewIDs.has(template.id))
    .map((template) => ({
      ...template,
      category: "accounting" as const,
      kind: "accounting" as const,
      sourcesKey: template.id === "estonia-tsd" ? "cowork.enterprise.reportTemplates.tsd.sources" as const
        : template.id === "estonia-kmd" ? "cowork.enterprise.reportTemplates.kmd.sources" as const : undefined,
    })),
  ...coworkPreviewReportTemplates,
]
